import { Box, Button, Grid, List, ListItem } from "@mui/material";
import { DrawerHeader } from "../../../components/Drawer/DrawerHeader";
import AlertComponent from "../../../components/AlertMessage/AlertMessage";
import { TEST_IDS } from "../consts/testIds";
import { TAB_INDEX } from "../Index";
import { current } from "@reduxjs/toolkit";
const getInfoPoints = ({ translate }: any): string[] => [
    translate('drawers.generateFilesSRT.info.rgrl.rb'),
    translate('drawers.generateFilesSRT.info.rgrl.rc'),
    translate('drawers.generateFilesSRT.info.rgrl.ri'),
    translate('drawers.generateFilesSRT.info.rgrl.rs'),
    translate('drawers.generateFilesSRT.info.rgrl.rm'),
    translate('drawers.generateFilesSRT.info.rgrl.ro'),
    translate('drawers.generateFilesSRT.info.rgrl.rh')
];

const getVisitsInfoPoints = ({ translate }: any): string[] => [
    translate('drawers.generateFilesSRT.info.visits.vi'),
    translate('drawers.generateFilesSRT.info.visits.rn'),
    translate('drawers.generateFilesSRT.info.visits.rd'),
];


const AlertContentRGRL = ({ infoPoints, currentTab }: { infoPoints: string[], currentTab: TAB_INDEX }) => {
    return (
        <List
            component="ol"
            sx={{
                listStyleType: 'decimal',
                pl: 2.2,
                pt: 2,
                pb: 4
            }}
        >
            <ListItem
                sx={{
                    fontSize: '16px',
                    padding: 0,
                    fontFamily: 'Roboto, sans-serif',
                    fontWeight: '600',
                    lineHeight: '18.75px'
                }}
            >
                {currentTab === TAB_INDEX.RGRL
                    ? 'RGRL'
                    : currentTab === TAB_INDEX.VISITS
                    ? 'Visitas'
                    : ''}
            </ListItem>
            {infoPoints.map((point: string, index: number) => (
                <ListItem
                    key={index}
                    sx={{
                        display: 'list-item',
                        fontSize: '16px',
                        padding: 0,
                        fontFamily: 'Roboto, sans-serif',
                        fontWeight: '500',
                        lineHeight: '18.75px'
                    }}
                >
                    {point}
                </ListItem>
            ))}
        </List>
    );
};

const GenerateFilesSRTDrawer = ({ translate, handleCloseDrawer, onSubmit, currentTab }: any) => {
    const infoPoints = getInfoPoints({ translate });
    const visitsInfoPoints = getVisitsInfoPoints({ translate });
    return (
        <Box
            display="flex"
            justifyContent="space-between"
            sx={{ flexDirection: 'column', height: '100%' }}
        >
            <Grid container>
                <DrawerHeader
                    onIconClick={handleCloseDrawer}
                    text={translate('drawers.generateFilesSRT.title')}
                />
                {currentTab === TAB_INDEX.RGRL && (
                    <AlertComponent
                        data-testid={TEST_IDS.drawers.generateFiles.infoAlert}
                        severity="info"
                        message={translate('drawers.generateFilesSRT.info.rgrl.message')}
                        sx={{
                            textAlign: 'left',
                            fontSize: '16px',
                            marginTop: 8,
                            ml: 2,
                            mr: 2
                        }}
                        content={
                            <AlertContentRGRL infoPoints={infoPoints} currentTab={currentTab} />
                        }
                        hideClose
                    />
                )}

                {currentTab === TAB_INDEX.VISITS && (
                    <AlertComponent
                        data-testid={TEST_IDS.drawers.generateFiles.infoAlert}
                        severity="info"
                        message={translate('drawers.generateFilesSRT.info.visits.message')}
                        sx={{
                            textAlign: 'left',
                            fontSize: '16px',
                            marginTop: 8,
                            ml: 2,
                            mr: 2
                        }}
                        content={<AlertContentRGRL infoPoints={visitsInfoPoints} currentTab={currentTab} />}
                        hideClose
                    />
                )}
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Button
                    variant="outlined"
                    onClick={handleCloseDrawer}
                    sx={{ mr: 1 }}
                    data-testid={TEST_IDS.drawers.generateFiles.buttons.cancel}
                >
                    {translate('drawers.buttons.cancel')}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onSubmit}
                    data-testid={TEST_IDS.drawers.generateFiles.buttons.submit}
                >
                    {translate('drawers.buttons.generateAndDownloadFiles')}
                </Button>
            </Box>
        </Box>
    );
}

export default GenerateFilesSRTDrawer;
